import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetUserAssociationsAction, userAction} from '../action';

const tableId = 'userAssociationsProfile';

function* execute({payload: {tableDataRequest}}: GetUserAssociationsAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findLoggedInUserAssociationRoles,
        successAction: userAction.getUserAssociationsSuccess,
        tableId,
    }));
}
export function* getUserAssociationsSaga(): SagaIterator {
    yield takeLatestF('user/GET_USER_ASSOCIATIONS', execute);
}
